import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import staffModalStyles from "pages/Staff/staff.module.scss";
import styles from "./CredentialsAndLicensingGlobalListing.module.scss";

const EXPIRY_STATUS_ITEMS = [
  {
    labelKey: "accountOwner.currentStatus",
    descriptionKey: "accountOwner.currentStatusDescription",
  },
  {
    labelKey: "accountOwner.expiringSoon",
    descriptionKey: "accountOwner.expiringSoonStatusDescription",
  },
  {
    labelKey: "accountOwner.expired",
    descriptionKey: "accountOwner.expiredStatusDescription",
  },
  {
    labelKey: "accountOwner.noExpiryStatus",
    descriptionKey: "accountOwner.noExpiryStatusDescription",
  },
  {
    labelKey: "accountOwner.expiryUnknownStatus",
    descriptionKey: "accountOwner.expiryUnknownStatusDescription",
  },
];

const DOCUMENTATION_STATUS_ITEMS = [
  {
    labelKey: "accountOwner.completedStatus",
    descriptionKey: "accountOwner.completedStatusDescription",
  },
  {
    labelKey: "accountOwner.proofMissingStatus",
    descriptionKey: "accountOwner.proofMissingStatusDescription",
  },
];

/**
 * Help guide content shared by Staff and Office credentials help modals.
 * @param {{
 *  titleKey: string,
 *  descriptionKey: string,
 *  viewAddEditKey: string,
 *  expiryStatusDescriptionKey: string,
 *  noteKey: string,
 *  t: Function,
 * }} props
 */
const HelpGuideContent = ({
  titleKey,
  descriptionKey,
  viewAddEditKey,
  expiryStatusDescriptionKey,
  noteKey,
  t,
}) => (
  <>
    <h5 className={staffModalStyles.title_style}>{t(titleKey)}</h5>
    <p>{t(descriptionKey)}</p>

    <h6 className={staffModalStyles.title_style}>
      {t("accountOwner.keyCapabilities")}
    </h6>
    <ul className={styles.helpGuideList}>
      <li className={styles.helpGuideListItem}>{t(viewAddEditKey)}</li>
      <li className={styles.helpGuideListItem}>
        {t("accountOwner.updateCredentialDetailsCapability")}
      </li>
      <li className={styles.helpGuideListItem}>
        {t("accountOwner.automatedExpiryRemindersCapability")}
      </li>
    </ul>

    <h6 className={staffModalStyles.title_style}>
      {t("accountOwner.expiryStatus")}
    </h6>
    <p>{t(expiryStatusDescriptionKey)}</p>
    <ul className={styles.helpGuideList}>
      {EXPIRY_STATUS_ITEMS.map(({ labelKey, descriptionKey: descKey }) => (
        <li key={labelKey} className={styles.helpGuideListItem}>
          <span className={styles.helpGuideInlineLabel}>{t(labelKey)}</span>
          {" – "}
          {t(descKey)}
        </li>
      ))}
    </ul>

    <h6 className={staffModalStyles.title_style}>
      {t("accountOwner.documentationStatus")}
    </h6>
    <p>{t("accountOwner.documentationStatusDescription")}</p>
    <ul className={styles.helpGuideList}>
      {DOCUMENTATION_STATUS_ITEMS.map(
        ({ labelKey, descriptionKey: descKey }) => (
          <li key={labelKey} className={styles.helpGuideListItem}>
            <span className={styles.helpGuideInlineLabel}>{t(labelKey)}</span>
            {" – "}
            {t(descKey)}
          </li>
        )
      )}
    </ul>

    <p className={styles.helpGuideNote}>{t(noteKey)}</p>
  </>
);

const CredentialAndLicensingHelpGuide = ({
  isOpen,
  onClose,
  t,
  isOfficeHelpModal = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffModalStyles.modal_container}>
          {isOfficeHelpModal ? (
            <HelpGuideContent
              titleKey="accountOwner.officeLicenses"
              descriptionKey="accountOwner.officeLicensesDescription"
              viewAddEditKey="accountOwner.officeViewAddEditCapability"
              expiryStatusDescriptionKey="accountOwner.officeExpiryStatusDescription"
              noteKey="accountOwner.officeLicensesNote"
              t={t}
            />
          ) : (
            <HelpGuideContent
              titleKey="accountOwner.staffLicenses"
              descriptionKey="accountOwner.staffLicensesDescription"
              viewAddEditKey="accountOwner.staffViewAddEditCapability"
              expiryStatusDescriptionKey="accountOwner.staffExpiryStatusDescription"
              noteKey="accountOwner.staffLicensesNote"
              t={t}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(CredentialAndLicensingHelpGuide);
